import { css } from '@emotion/css';

import { m } from '../../../motif';
import { globalHeaderTransitionDuration } from '../GlobalHeader.constants';

/** Styles for the animated icon used in the mobile header navigation button. */
export const dotsGroupContainerCss = css`
  background-color: transparent;
  cursor: pointer;
  display: grid;
  grid-template-columns: repeat(2, 12px);
  grid-template-rows: repeat(2, 12px);
  height: 24px;
  margin: 0;
  max-height: 24px;
  max-width: 24px;
  user-select: none;
  width: 24px;
  transition: transform ${globalHeaderTransitionDuration}ms ease-in-out;

  &.expanded {
    transform: rotate(-180deg);

    .dot {
      animation: dot-animation ${globalHeaderTransitionDuration}ms ease-out forwards;
    }
  }

  &.collapsed {
    transform: rotate(0deg);

    .dot {
      animation: dot-animation-reverse ${globalHeaderTransitionDuration}ms ease-in forwards;
    }
  }

  /* RTL overrides - placed after base rules to satisfy specificity ordering */
  [dir='rtl'] &.expanded {
    transform: rotate(180deg); /* Mirror: rotate clockwise instead of counter-clockwise */
  }

  [dir='rtl'] &.expanded .dot {
    animation: dot-animation-rtl ${globalHeaderTransitionDuration}ms ease-out forwards;
  }

  [dir='rtl'] &.collapsed .dot {
    animation: dot-animation-reverse-rtl ${globalHeaderTransitionDuration}ms ease-in forwards;
  }

  /** Animation for the dots when expanding */
  @keyframes dot-animation {
    0% {
      border-radius: 50%;
      transform: translateX(0) scale(1, 1);
    }
    15% {
      border-radius: 50%;
      transform: translateX(0) scale(1, 1);
    }
    100% {
      border-radius: 0%;
      transform: translateX(4px) scale(2, 0.35);
    }
  }

  @keyframes dot-animation-rtl {
    0% {
      border-radius: 50%;
      transform: translateX(0) scale(1, 1);
    }
    15% {
      border-radius: 50%;
      transform: translateX(0) scale(1, 1);
    }
    100% {
      border-radius: 0%;
      transform: translateX(-4px) scale(2, 0.35);
    }
  }

  /** Animation for the dots when collapsing */
  @keyframes dot-animation-reverse {
    0% {
      border-radius: 0%;
      transform: translateX(4px) scale(2, 0.35);
    }
    85% {
      border-radius: 50%;
      transform: translateX(0) scale(1, 1);
    }
    100% {
      border-radius: 50%;
      transform: translateX(0) scale(1, 1);
    }
  }

  @keyframes dot-animation-reverse-rtl {
    0% {
      border-radius: 0%;
      transform: translateX(-4px) scale(2, 0.35);
    }
    85% {
      border-radius: 50%;
      transform: translateX(0) scale(1, 1);
    }
    100% {
      border-radius: 50%;
      transform: translateX(0) scale(1, 1);
    }
  }
`;

export const dotContainerCss = css`
  align-items: center;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
`;

export const dotCss = css`
  background-color: ${m('--fg-color')};
  border-radius: 50%;
  height: 7px;
  width: 7px;
`;

export const dotTopLeftCss = css`
  rotate: 45deg;

  [dir='rtl'] & {
    rotate: -45deg;
  }
`;

export const dotBottomLeftCss = css`
  rotate: -45deg;

  [dir='rtl'] & {
    rotate: 45deg;
  }
`;

export const dotTopRightCss = css`
  rotate: 135deg;

  [dir='rtl'] & {
    rotate: -135deg;
  }
`;

export const dotBottomRightCss = css`
  rotate: -135deg;

  [dir='rtl'] & {
    rotate: 135deg;
  }
`;
